import { WHITELABEL_DATA } from 'Constants'
import { APIRequest } from 'store/RootStore'
import { parse } from 'tldts'

export function getRegisteredDomain(url: string): string | null {
  const { domain } = parse(url)
  return domain || null
}

export default function useWhiteLabel(): {
  getWhiteLabelData: any
} {
  const API_URL = 'https://o1j0okg6yj.execute-api.ap-southeast-2.amazonaws.com/'
  const getWhiteLabelData = async () => {
    try {
      const requestOptions: RequestInit = {
        method: 'GET',
        // headers,
        cache: 'no-cache',
        redirect: 'follow',
      }

      // const location = getRegisteredDomain('https://arinasfilmmaker.com/')
      const location = getRegisteredDomain(window.location.hostname)
      let endpoint: string | null = null

      if (!location) {
        return console.log('Domain not found')
      }

      // const whiteLabelMatch = {
      //   appname: 'maharaniproduction',
      //   title:
      //     'Maharani Production | Film & Media Production & Distribution Company',
      //   code: 'maharaniproduction',
      //   url: 'film.maharaniproduction.com',
      // }
      const whiteLabelMatch = WHITELABEL_DATA.find((data) =>
        location.includes(data.url)
      )

      if (whiteLabelMatch) {
        endpoint = `${API_URL}whitelabel?wlabel=${whiteLabelMatch.appname}`
      } else {
        const subdomain = getSubdomain(location)
        if (
          !['', 'dev', 'master', 'app', 'whitelabel', 'localhost'].includes(
            subdomain
          )
        ) {
          localStorage.removeItem('affiliate')
          endpoint = `${API_URL}whitelabel?wlabel=${subdomain}`
        }
      }

      if (endpoint) {
        const response = await APIRequest(endpoint, requestOptions)
        return await response
      }
    } catch (err) {
      console.error(err)
    }
  }

  const getSubdomain = (location: string) => {
    let locationParts = location.split('.')

    locationParts = locationParts.filter((part) => part !== 'www')

    let sliceTill = -2

    const isLocalHost = locationParts.slice(-1)[0] === 'localhost'
    if (isLocalHost) sliceTill = -1

    return locationParts[0] || ''
  }

  return {
    getWhiteLabelData,
  }
}

export {}
